import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from './ViewPopup'
import {Sound} from '../Sound'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {CA} from '../analytics/Analytics'

export class ViewPopupKeepPlayingOnWeb extends ViewPopup {
    constructor(continuationAction: () => void) {
        const title: TranslationObject = {key: 'strings:popups.keepPlayingOnWeb.title'}
        const body: TranslationObject = {key: 'strings:popups.keepPlayingOnWeb.body'}

        super(title, body, () => undefined, () => undefined, true)

        this.xButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
            continuationAction()
        }

        this.checkButton.id = 'root-href'

        this.show()

        ViewPopupKeepPlayingOnWeb.sendAnalytic()
    }

    static sendAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.DiscordPopupKeepPlayingOnWeb,
            category: AnalyticEventCategory.DiscordConvertToWeb,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}
